import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, SearchIcon, FilterIcon, ChevronDownIcon, CheckCircleIcon, AlertCircleIcon, ClockIcon, BarChart2Icon, PieChartIcon, UsersIcon, CalendarIcon, RefreshCwIcon, SlidersIcon, DownloadIcon, XCircleIcon, FileTextIcon, InfoIcon, EyeIcon, PlusIcon } from 'lucide-react';
export function ClaimsReportsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  // Mock data for metrics
  const metrics = {
    totalClaims: 152,
    pendingClaims: 37,
    approvedClaims: 98,
    rejectedClaims: 17,
    avgResponseTime: '3.2 days',
    warrantyRate: '64%'
  };
  // Mock data for claims
  const claimsData = [{
    id: '202534704',
    date: 'Jul 7, 2025',
    dealer: 'AGRO+ SRL',
    reportedBy: 'GIULIA OGNIBENE',
    responsible: 'Régis SIMIER',
    type: 'Warranty',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528724',
    date: 'Jun 30, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Missing part',
    status: 'Requested',
    isNew: true
  }, {
    id: '202523188',
    date: 'Jun 27, 2025',
    dealer: 'YUGAGROPOLIV LLC',
    reportedBy: 'Evgeny Radchenko',
    responsible: 'Evgeny Radchenko',
    type: 'Warranty',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528723',
    date: 'Jun 26, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Technical issue',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528722',
    date: 'Jun 26, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Technical issue',
    status: 'Approved',
    isNew: false
  }, {
    id: '202559',
    date: 'Jun 24, 2025',
    dealer: '',
    reportedBy: 'Daniel Fernández',
    responsible: 'Murad Elafsheh',
    type: 'Technical issue by region',
    status: 'Requested',
    isNew: true
  }, {
    id: '202558',
    date: 'Jun 24, 2025',
    dealer: '',
    reportedBy: 'Daniel Fernández',
    responsible: 'Murad Elafsheh',
    type: 'Technical issue by region',
    status: 'Requested',
    isNew: true
  }];
  // Filter claims based on active tab
  const filteredClaims = claimsData.filter(claim => {
    if (activeTab === 'active') {
      return claim.status === 'Requested' || claim.status === 'In Progress';
    } else {
      return claim.status === 'Approved' || claim.status === 'Rejected';
    }
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-7644">
      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-white" data-id="element-7645">
        <div className="container mx-auto px-6 py-6" data-id="element-7646">
          <div className="flex justify-between items-center" data-id="element-7647">
            <div className="flex items-center" data-id="element-7648">
              <button onClick={() => navigate('/support')} className="mr-3 p-2 hover:bg-blue-900/50 rounded-full transition-colors" data-id="element-7649">
                <ArrowLeftIcon size={20} data-id="element-7650" />
              </button>
              <h1 className="text-2xl font-bold" data-id="element-7651">Claims Reports</h1>
            </div>
            <div className="flex gap-3" data-id="element-7652">
              <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors flex items-center shadow-sm" data-id="element-7653">
                <PlusIcon size={18} className="mr-2" data-id="element-7654" />
                Report New Claim
              </button>
              <button className="px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg transition-colors flex items-center border border-blue-700/30" data-id="element-7655">
                <DownloadIcon size={18} className="mr-2" data-id="element-7656" />
                Export
              </button>
            </div>
          </div>
          {/* Tabs */}
          <div className="flex mt-6 border-b border-blue-800/50" data-id="element-7657">
            <button className={`px-5 py-3 ${activeTab === 'active' ? 'border-b-2 border-white font-medium' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('active')} data-id="element-7658">
              Active Claims
            </button>
            <button className={`px-5 py-3 ${activeTab === 'closed' ? 'border-b-2 border-white font-medium' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('closed')} data-id="element-7659">
              Closed Claims
            </button>
          </div>
        </div>
      </div>
      {/* Metrics Panels */}
      <div className="container mx-auto px-6 py-6" data-id="element-7660">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6" data-id="element-7661">
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7662">
            <div className="flex items-center justify-between mb-3" data-id="element-7663">
              <h3 className="text-gray-500 font-medium" data-id="element-7664">Claims Overview</h3>
              <BarChart2Icon className="text-blue-600" size={20} data-id="element-7665" />
            </div>
            <div className="grid grid-cols-3 gap-2" data-id="element-7666">
              <div className="text-center" data-id="element-7667">
                <div className="text-3xl font-bold text-blue-600" data-id="element-7668">
                  {metrics.totalClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7669">Total</div>
              </div>
              <div className="text-center" data-id="element-7670">
                <div className="text-3xl font-bold text-amber-500" data-id="element-7671">
                  {metrics.pendingClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7672">Pending</div>
              </div>
              <div className="text-center" data-id="element-7673">
                <div className="text-3xl font-bold text-green-500" data-id="element-7674">
                  {metrics.approvedClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7675">Approved</div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7676">
            <div className="flex items-center justify-between mb-3" data-id="element-7677">
              <h3 className="text-gray-500 font-medium" data-id="element-7678">Claim Types</h3>
              <PieChartIcon className="text-indigo-600" size={20} data-id="element-7679" />
            </div>
            <div className="flex items-center justify-center h-16" data-id="element-7680">
              <div className="flex items-center gap-4" data-id="element-7681">
                <div className="flex flex-col items-center" data-id="element-7682">
                  <div className="flex items-center" data-id="element-7683">
                    <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-7684"></div>
                    <span className="text-sm text-gray-600" data-id="element-7685">Warranty</span>
                  </div>
                  <span className="font-bold" data-id="element-7686">{metrics.warrantyRate}</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-7687">
                  <div className="flex items-center" data-id="element-7688">
                    <div className="w-3 h-3 rounded-full bg-amber-500 mr-1" data-id="element-7689"></div>
                    <span className="text-sm text-gray-600" data-id="element-7690">Technical</span>
                  </div>
                  <span className="font-bold" data-id="element-7691">24%</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-7692">
                  <div className="flex items-center" data-id="element-7693">
                    <div className="w-3 h-3 rounded-full bg-green-500 mr-1" data-id="element-7694"></div>
                    <span className="text-sm text-gray-600" data-id="element-7695">Missing</span>
                  </div>
                  <span className="font-bold" data-id="element-7696">12%</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7697">
            <div className="flex items-center justify-between mb-3" data-id="element-7698">
              <h3 className="text-gray-500 font-medium" data-id="element-7699">Response Time</h3>
              <ClockIcon className="text-amber-600" size={20} data-id="element-7700" />
            </div>
            <div className="flex flex-col items-center justify-center h-16" data-id="element-7701">
              <div className="text-3xl font-bold text-amber-600" data-id="element-7702">
                {metrics.avgResponseTime}
              </div>
              <div className="text-sm text-gray-500" data-id="element-7703">Average response time</div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7704">
            <div className="flex items-center justify-between mb-3" data-id="element-7705">
              <h3 className="text-gray-500 font-medium" data-id="element-7706">Status Distribution</h3>
              <PieChartIcon className="text-green-600" size={20} data-id="element-7707" />
            </div>
            <div className="space-y-3" data-id="element-7708">
              <div data-id="element-7709">
                <div className="flex justify-between text-sm mb-1" data-id="element-7710">
                  <span className="text-gray-600" data-id="element-7711">Approved</span>
                  <span className="font-medium text-gray-800" data-id="element-7712">
                    {metrics.approvedClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7713">
                  <div className="bg-green-500 h-2 rounded-full" style={{
                  width: `${metrics.approvedClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7714"></div>
                </div>
              </div>
              <div data-id="element-7715">
                <div className="flex justify-between text-sm mb-1" data-id="element-7716">
                  <span className="text-gray-600" data-id="element-7717">Pending</span>
                  <span className="font-medium text-gray-800" data-id="element-7718">
                    {metrics.pendingClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7719">
                  <div className="bg-amber-500 h-2 rounded-full" style={{
                  width: `${metrics.pendingClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7720"></div>
                </div>
              </div>
              <div data-id="element-7721">
                <div className="flex justify-between text-sm mb-1" data-id="element-7722">
                  <span className="text-gray-600" data-id="element-7723">Rejected</span>
                  <span className="font-medium text-gray-800" data-id="element-7724">
                    {metrics.rejectedClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7725">
                  <div className="bg-red-500 h-2 rounded-full" style={{
                  width: `${metrics.rejectedClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7726"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Search and Filters */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6 overflow-hidden" data-id="element-7727">
          <div className="p-5 border-b border-gray-100" data-id="element-7728">
            <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-7729">
              <div className="relative flex-1 min-w-[300px]" data-id="element-7730">
                <input type="text" placeholder="Search by code, reported by or responsible" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-7731" />
                <SearchIcon className="absolute left-3 top-3 text-gray-400" size={18} data-id="element-7732" />
              </div>
              <div className="flex items-center gap-3" data-id="element-7733">
                <button className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center" onClick={() => setShowFilters(!showFilters)} data-id="element-7734">
                  <SlidersIcon size={18} className="mr-2" data-id="element-7735" />
                  Filters
                  <ChevronDownIcon size={16} className="ml-1" data-id="element-7736" />
                </button>
                <button className="px-3 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors flex items-center" data-id="element-7737">
                  <RefreshCwIcon size={16} className="mr-1" data-id="element-7738" />
                  Reset
                </button>
              </div>
            </div>
            {/* Expanded filters */}
            {showFilters && <div className="mt-4 pt-4 border-t border-gray-100 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7739">
                <div className="relative" data-id="element-7740">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7741">
                    Status
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7742">
                    <option data-id="element-7743">All statuses</option>
                    <option data-id="element-7744">Requested</option>
                    <option data-id="element-7745">In Progress</option>
                    <option data-id="element-7746">Approved</option>
                    <option data-id="element-7747">Rejected</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7748" />
                </div>
                <div className="relative" data-id="element-7749">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7750">
                    Dealer
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7751">
                    <option data-id="element-7752">All dealers</option>
                    <option data-id="element-7753">AGRO+ SRL</option>
                    <option data-id="element-7754">ZEPPELIN</option>
                    <option data-id="element-7755">YUGAGROPOLIV LLC</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7756" />
                </div>
                <div className="relative" data-id="element-7757">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7758">
                    Claim Type
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7759">
                    <option data-id="element-7760">All claim types</option>
                    <option data-id="element-7761">Warranty</option>
                    <option data-id="element-7762">Technical issue</option>
                    <option data-id="element-7763">Missing part</option>
                    <option data-id="element-7764">Technical issue by region</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7765" />
                </div>
                <div className="relative" data-id="element-7766">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7767">
                    Date Range
                  </label>
                  <input type="date" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7768" />
                </div>
                <div className="relative" data-id="element-7769">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7770">
                    Responsible
                  </label>
                  <input type="text" placeholder="Filter by responsible person" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7771" />
                </div>
                <div className="relative" data-id="element-7772">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7773">
                    Reported By
                  </label>
                  <input type="text" placeholder="Filter by reporter" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7774" />
                </div>
              </div>}
          </div>
          {/* Active filters */}
          <div className="px-5 py-3 bg-gray-50 flex flex-wrap items-center gap-2" data-id="element-7775">
            <span className="text-sm text-gray-500 mr-2" data-id="element-7776">Active filters:</span>
            <span className="bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full flex items-center" data-id="element-7777">
              Status: Requested
              <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-7778" />
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full flex items-center" data-id="element-7779">
              Dealer: ZEPPELIN
              <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-7780" />
            </span>
          </div>
        </div>
        {/* Claims Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-7781">
          <div className="overflow-x-auto" data-id="element-7782">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-7783">
              <thead className="bg-gray-50" data-id="element-7784">
                <tr data-id="element-7785">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7786">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7787">
                    Claim
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7788">
                    Dealer
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7789">
                    Reported by
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7790">
                    Responsible
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7791">
                    Claim type
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7792">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-7793">
                {filteredClaims.map(claim => <tr key={claim.id} className="hover:bg-gray-50 transition-colors" data-id="element-7794">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-7795">
                      <div className="flex items-center" data-id="element-7796">
                        {claim.status === 'Approved' ? <CheckCircleIcon size={16} className="text-green-500 mr-2" data-id="element-7797" /> : claim.status === 'Requested' ? <ClockIcon size={16} className="text-amber-500 mr-2" data-id="element-7798" /> : <AlertCircleIcon size={16} className="text-red-500 mr-2" data-id="element-7799" />}
                        <span className={`px-2 py-1 text-xs rounded-full ${claim.status === 'Approved' ? 'bg-green-100 text-green-800' : claim.status === 'Rejected' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-7800">
                          {claim.status}
                        </span>
                      </div>
                      {claim.isNew && <span className="ml-6 mt-1 inline-block px-2 py-0.5 text-xs bg-blue-500 text-white rounded-full" data-id="element-7801">
                          New
                        </span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-7802">
                      <div className="text-sm font-medium text-gray-900" data-id="element-7803">
                        {claim.id}
                      </div>
                      <div className="text-xs text-gray-500 flex items-center" data-id="element-7804">
                        <CalendarIcon size={12} className="mr-1" data-id="element-7805" />
                        {claim.date}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-7806">
                      {claim.dealer ? <div className="text-sm text-gray-900" data-id="element-7807">
                          {claim.dealer}
                        </div> : <span className="text-xs text-gray-500" data-id="element-7808">—</span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-7809">
                      {claim.reportedBy}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-7810">
                      {claim.responsible}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-7811">
                      <div className="flex items-center" data-id="element-7812">
                        <span className={`px-2 py-1 text-xs rounded-full ${claim.type === 'Warranty' ? 'bg-blue-100 text-blue-800' : claim.type === 'Missing part' ? 'bg-purple-100 text-purple-800' : 'bg-indigo-100 text-indigo-800'}`} data-id="element-7813">
                          {claim.type}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-7814">
                      <div className="flex items-center justify-end space-x-2" data-id="element-7815">
                        <button className="p-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors" data-id="element-7816">
                          <EyeIcon size={16} data-id="element-7817" />
                        </button>
                        <button className="p-1.5 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-7818">
                          <FileTextIcon size={16} data-id="element-7819" />
                        </button>
                        <button className="p-1.5 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-7820">
                          <InfoIcon size={16} data-id="element-7821" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          {filteredClaims.length === 0 && <div className="text-center py-12" data-id="element-7822">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-7823">
                <FileTextIcon size={24} className="text-gray-400" data-id="element-7824" />
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-7825">
                No claims found
              </h3>
              <p className="text-gray-500" data-id="element-7826">
                Try adjusting your filters or search criteria
              </p>
            </div>}
        </div>
        {/* Pagination */}
        <div className="flex items-center justify-between" data-id="element-7827">
          <div className="text-sm text-gray-600" data-id="element-7828">
            Showing <span className="font-medium" data-id="element-7829">1</span> to{' '}
            <span className="font-medium" data-id="element-7830">{filteredClaims.length}</span> of{' '}
            <span className="font-medium" data-id="element-7831">{filteredClaims.length}</span> claims
          </div>
          <div className="flex items-center space-x-2" data-id="element-7832">
            <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-7833">
              Previous
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-blue-600 text-white font-medium" data-id="element-7834">
              1
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-7835">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}